import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ToolData } from '../../types/common';
import { BackOfficeService } from 'src/app/back-office-pages/back-office.service';
import { VariantService } from 'src/app/admin-pages/variant.service';
// import { FcmService } from 'src/app/services/fcm.service';
import { ConfigService } from 'src/app/services/config.service';
import { environment } from 'src/environments/environment';
// import { ModalService } from 'src/app/services/model.service';


@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
  @Input() toolbarDetails: ToolData;
  @Output() Reload = new EventEmitter<boolean>();
  @Output() ChangeShop = new EventEmitter<boolean>();
  @Output() rp = new EventEmitter<boolean>();
  @Output() onSearchClicked = new EventEmitter<boolean>();
  @Output() onFilterClick = new EventEmitter<boolean>();
  @Output() Edit = new EventEmitter<boolean>();
  @Output() Cancel = new EventEmitter<boolean>();
  @Output() return = new EventEmitter<boolean>();
  @Output() addTran = new EventEmitter<boolean>();
  @Output() Add = new EventEmitter<boolean>();
  @Output() back = new EventEmitter<boolean>();
  @Output() StockEdit = new EventEmitter<boolean>();
  @Output() PriceEdit = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<boolean>();
  @Output() download = new EventEmitter<boolean>();
  @Output() downloadExcel = new EventEmitter<boolean>();
  @Output() sHowProducts = new EventEmitter<boolean>();

  isSearchActive: boolean = false;
  isFilterActive: boolean = false;
  selectedShop: any = { key: 0, a: 'dssdf' };
  originalUser: any;
  loginDetails: any = {};
  isApiError: boolean;
  isShowLogOutConfirm: boolean;
  shopList: any = [{ ShopName: 'All', ID: 0 }];
  CartCount: number = 0;
  selectedUser: any = {};
  isRouteUser: boolean;
  iSelectedRoute: boolean;
  loggedInUserID: number = 0;
  isShowReportList: boolean = false;

  isSuperAdmin!: boolean;
  isSelectedSuper!: boolean;
  adminDetails: any;

  isReseller!: boolean;
  shopeDomainName: any;
  appName: string;
  registrationData: any;
  isCollapsed: boolean = true;
  isThirdParty: boolean = false;

  constructor(
    private router: Router,
    private backOfficeService: BackOfficeService,
    public apiService: ApiService,
    private vs: VariantService,
    // private fcmService: FcmService,
    public configService: ConfigService,
    // public modalService:ModalService
  ) {

    this.isReseller = this.configService.isReseller;
  }

  ngOnInit(): void {
    this.toolbarDetails.isShowShopNameFilter = true;
    this.setUpUser();

    const user = this.apiService.getSelectedUser();
    this.loggedInUserID = user?.ID ?? 0;
    this.adminDetails = this.apiService.getRealUserData();

    // this.openSideNav();

    if (window.location.href.includes(environment.thirdPartyUserKey) && window.location.href.includes(environment.thirdPartyAppURL)) {
      this.isThirdParty = true;
    }
  }

  public openSideNav() {
    document.getElementById("mySidenav").style.width = "75%";
    document.getElementById("myCloseContainer").style.width = "25%";
  }

  public closeSideNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("myCloseContainer").style.width = "0";

  }

  public gotoPage(path) {
    this.router.navigate([path]);
    this.closeSideNav();
  }

  showReports(event: boolean) {
    if (this.isShowReportList === false) {
      this.isShowReportList = true;
    } else {
      this.isShowReportList = false;
    }
  }

  public logOutClicked() {
    this.configService.isShowLogOutConfirm = true;
    this.closeSideNav();
    // this.modalService.open(logoutTemplate, false, this.isShowLogOutConfirm);
  }


  public confirmLogOut() {
    // let appVersion = localStorage.getItem('appVersion') != null ? localStorage.getItem('appVersion') : 0;
    let appConfig = localStorage.getItem("appConfig");
    let uuid = localStorage.getItem("uuid");
    // this.fcmService.unsubscribeNotification();
    // this.fcmService.deregisterServiceWorker();

    localStorage.clear();

    // localStorage.setItem('appVersion', appVersion.toString());
    localStorage.setItem('appConfig', appConfig);
    uuid ? localStorage.setItem('uuid', uuid) : '';

    this.router.navigate(['/public/login']);
  }

  ActivateSearch() {
    this.isSearchActive = !this.isSearchActive;
    this.onSearchClicked.emit(this.isSearchActive);
  }

  public filterClick() {
    // this.isFilterActive = !this.isFilterActive;
    // this.onFilterClick.emit(this.isFilterActive)
    this.onFilterClick.emit(true);
  }

  public goBack() {
    // this.location.back();
    this.back.emit(true);
  }

  public clearUserSelection() {
    this.backOfficeService.clearCustomerSelection();
    this.setUpUser();
    this.gotoPage('/user/userlist');
  }

  private setUpUser() {
    this.selectedUser = this.apiService.getSelecterUserData();
    this.originalUser = this.apiService.getRealUserData();

    this.isRouteUser = this.originalUser?.UserType === 'admin' ? true : false; //removed soon
    this.iSelectedRoute =
      this.selectedUser?.UserType === 'admin' ? true : false; //removed soon

    this.isSuperAdmin =
      this.originalUser.UserType == 'superadmin' ? true : false;
    this.isSelectedSuper =
      this.selectedUser.UserType == 'superadmin' ? true : false;
  }

  public gotoAddProduct() {
    if (this.isReseller) {
      this.router.navigate(['/Reseller/AddProduct']);
    } else {
      if (location.hash.split('/')[2] == "product-edit") {
        this.vs.initVariantService(0);
      }
      this.router.navigate(['/products/product-edit', 0]);
    }
    this.closeSideNav();
  }

  ShareMyStore() {
    const shopeDomainName = this.configService.getLoginDetails()?.SubDomain;
    const appName = environment.appName.toLowerCase();
    const shareableLink = `https://${shopeDomainName}`;

    if (shopeDomainName && appName) {
      if (navigator.share) {
        navigator.share({
          title: 'Share My Store',
          text: 'Check out my store',
          url: shareableLink,
        }).catch((error) => {
          console.error('Sharing failed:', error);
        });
      }
    } else {

    }
    this.closeSideNav();
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

}
